export * from './get-window-object';
export * from './has-form-data';
export * from './has-retina-screen';
export * from './has-window-listeners';
export * from './has-window';
export * from './is-thenable';
